export default __webpack_public_path__ + "static/media/IconDownload.0847de0f.svg";